import React from 'react';
import { useIntl } from '@olxpwa-lib/i18n/client';
import { Button } from '@olxui/core/dist/core/Button';
import Error from '@olxui/core/dist/core/Icon/icons/illustrations/Error';
import styled from '@olxui/core/dist/theme/styled';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60vh;
    flex-direction: column;
`;

const StyledErrorIcon = styled(Error)`
    width: 20%;
    height: 20%;
`;

const ErrorPage = () => {
    const { formatMessage } = useIntl();
    return (
        <Wrapper>
            <StyledErrorIcon />
            <h1>
                {formatMessage({
                    id: 'service.booking.panel.error',
                    defaultMessage: 'Something went wrong!'
                })}
            </h1>

            <Button onClick={() => window.location.reload()}>
                {formatMessage({
                    id: 'service.booking.panel.refresh',
                    defaultMessage: 'Refresh the page'
                })}
            </Button>
        </Wrapper>
    );
};

export default ErrorPage;
